"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWindowSize = useWindowSize;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _canUseDOM = require("../utils/canUseDOM");

var getSize = function getSize() {
  if (!_canUseDOM.canUseDOM) {
    return {
      width: 0,
      height: 0
    };
  }

  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
};

function useWindowSize() {
  var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;

  var _useState = (0, _react.useState)(getSize()),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      windowSize = _useState2[0],
      setWindowSize = _useState2[1];

  (0, _react.useEffect)(function () {
    if (_canUseDOM.canUseDOM) {
      var timeout;

      var handleResize = function handleResize() {
        clearTimeout(timeout);
        timeout = window.setTimeout(function () {
          return setWindowSize(getSize());
        }, delay);
      };

      window.addEventListener('resize', handleResize);
      return function () {
        return window.removeEventListener('resize', handleResize);
      };
    }

    return function () {
      return null;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return windowSize;
}